import React, { useEffect, useState } from 'react';
import { Link} from 'react-router-dom';

function OrdersPage() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  //const navigate = useNavigate();

  useEffect(() => {
    const fetchOrders = async () => {
      const token = localStorage.getItem('adminToken');

      if (!token) {
        setError('Unauthorized: Admin token missing');
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/admin/orders`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Failed to fetch orders');
        }

        const data = await response.json();
        setOrders(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, []);

  const getStatusBadgeClass = (status) => {
    switch (status?.toLowerCase()) {
      case 'processing':
        return 'badge bg-warning text-dark';
      case 'confirmed':
        return 'badge bg-primary';
      case 'shipped':
        return 'badge bg-info text-dark';
      case 'delivered':
        return 'badge bg-success';
      case 'cancelled':
        return 'badge bg-danger';
      default:
        return 'badge bg-secondary';
    }
  };

  return (
    <div className="container my-4">
      <h2 className="mb-4">Orders</h2>

      {loading ? (
        <div>Loading orders...</div>
      ) : error ? (
        <div className="alert alert-danger">{error}</div>
      ) : orders.length === 0 ? (
        <div>No orders found.</div>
      ) : (
        <div className="table-responsive rounded border p-3 bg-white">
          <table className="table table-bordered table-hover align-middle mb-0 rounded">
            <thead className="table-light">
              <tr>
                <th style={{ width: '3rem' }} className="py-3 px-2">#</th>
                <th className="py-3 px-2">Order ID</th>
                <th className="py-3 px-2">Customer</th>
                <th className="py-3 px-2">Items</th>
                <th className="py-3 px-2">Total (₹)</th>
                <th className="py-3 px-2">Payment</th>
                <th className="py-3 px-2">Status</th>
                <th className="py-3 px-2">Placed At</th>
                <th style={{ width: '11rem' }} className="py-3 px-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order, index) => (
                <tr key={order.orderId}>
                  <td className="py-2 px-2">{index + 1}</td>
                  <td className="py-2 px-2">
                    {order.orderId}
                    {order.status === 'Processing' && (
                      <span className="badge bg-danger ms-2">New</span>
                    )}
                  </td>
                  <td className="py-2 px-2">{order.deliveryDetails?.name || 'N/A'}</td>
                  <td className="py-2 px-2">{order.items?.length || 0}</td>
                  <td className="py-2 px-2">{order.totalPrice?.toFixed(2) || '0.00'}</td>
                  <td className="py-2 px-2">{order.paymentMethod || 'Cash on Delivery'}</td>
                  <td className="py-2 px-2">
                    <span className={getStatusBadgeClass(order.status)}>{order.status}</span>
                  </td>
                  <td className="py-2 px-2">
                    {order.createdAt
                      ? new Date(order.createdAt).toLocaleString()
                      : 'N/A'}
                  </td>
                  <td className="py-2 px-2">
                    <Link
                      to={`/orders/${order.orderId}`}
                      className="btn btn-sm btn-outline-success py-1 my-1 px-3 me-2 mb-1 rounded"
                    >
                      View
                    </Link>
                    <Link
                      to={`/orders/${order.orderId}/status`}
                      className="btn btn-sm btn-dark py-1 px-3 my-1 mb-1 rounded"
                    >
                      Edit
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default OrdersPage;
